import { useUser } from '@/hooks/useUser';

import { AuthenticatedFollowNarrative } from './AuthenticatedFollowNarrative';
import type { Narrative } from './AuthenticatedFollowNarrative';
import { UnauthenticatedFollowNarrative } from './UnauthenticatedFollowNarrative';

type Props = {
  narrative: Narrative;
};

export const FollowNarrative = ({ narrative }: Props) => {
  const { data: user } = useUser();

  if (user.loggedIn) {
    return <AuthenticatedFollowNarrative narrative={narrative} />;
  }

  return <UnauthenticatedFollowNarrative />;
};
